import * as React from 'react';

import { Link, LinkProps } from 'react-router-dom';

export type AbstractActionProps = React.HTMLProps<HTMLAnchorElement> | React.HTMLProps<HTMLButtonElement> | LinkProps;

export interface ActionButtonProps {
  /** React router link path */
  to?: string;
  /** Use the same tab on external href */
  sameTab?: boolean;
  /** Action click handler */
  onClick?: () => void;
  /** Action label */
  label: string;
  /** Font awesome icon name */
  iconName?: string;
  /** If primary */
  primary?: boolean;
  /** Test identifier */
  testId?: string;
}

export const ActionButton: React.SFC<ActionButtonProps & AbstractActionProps> = ({
  primary,
  href,
  sameTab,
  iconName,
  label,
  to,
  onClick,
  children,
  testId,
  ...rest
}) => {
  const className = primary ? 'btn btn-primary btn-action-primary' : 'btn btn-link btn-sm btn-action';
  if (href) {
    return (
      <a
        href={href}
        rel="noopener"
        target={sameTab ? undefined : '_blank'}
        className={className}
        data-testid={testId}
        {...rest as React.HTMLProps<HTMLAnchorElement>}
      >
        {iconName && (
          <span>
            <i className={`fa fa-${iconName}`} />{' '}
          </span>
        )}
        {label}
      </a>
    );
  } else if (to) {
    return (
      <Link to={to} className={className} data-testid={testId} {...rest as LinkProps}>
        {iconName && (
          <span>
            <i className={`fa fa-${iconName}`} />{' '}
          </span>
        )}
        {label}
      </Link>
    );
  } else {
    return (
      <button
        className={className}
        type="button"
        onClick={onClick}
        data-testid={testId}
        {...rest as React.HTMLProps<HTMLButtonElement>}
      >
        {iconName && (
          <span>
            <i className={`fa fa-${iconName}`} />{' '}
          </span>
        )}
        {label}
      </button>
    );
  }
};



// WEBPACK FOOTER //
// ./src/common/components/layout/Page/ActionButton.tsx